export default __webpack_public_path__ + "static/media/JumpCloud.9b402c26.svg";